<template>
  <div
    class="text-white d-flex align-items-center justify-content-between py-1 px-2 position-sticky sticky-top"
    style="background-color: var(--dark)"
  >
    <div class="py-2 d-flex align-items-center">
      <button
        class="btn"
        data-bs-toggle="offcanvas"
        data-bs-target="#navigation"
        aria-controls="navigation"
      >
        <img
          src="https://core.futurerent.co.za/menu-icon.svg"
          alt="Menu Icon"
        />
      </button>
      <div class="px-3 d-flex align-items-center">
        <span
          id="logo"
          style="
            cursor: pointer;
            width: 140px;
            background-color: rgba(255, 255, 255, 0.09);
          "
          class="px-2 pt-1 pb-2 rounded-1"
        >
          <img
            src="https://cdn.futurerent.co.za/media/futurerent-logo-white.svg"
            alt="FutureRent Logo"
            style="width: 100%"
          />
        </span>
        <div class="px-3">
          <span class="fs-5 fw-bolder">Core / Dashboard</span>
        </div>
      </div>
    </div>
    <div class="d-flex pe-3" style="cursor: pointer">
      <div class="d-flex align-items-center pe-3">
        <button class="btn">
          <i class="ph-bold ph-magnifying-glass text-white fs-4"></i>
        </button>
        <button class="btn">
          <i class="ph-bold ph-bell text-white fs-4"></i>
        </button>
      </div>
      <div class="p-3 bg-white rounded position-relative" profile-picture>
        <span
          class="position-absolute text-dark fw-bold top-50 left-50 translate-middle fs-4"
          >FD</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavComp",
};
</script>

<style scoped>
[profile-picture] {
  aspect-ratio: 1;
  width: 40px;
}
</style>
